import { render, staticRenderFns } from "./CreateFormulaTemplateForm.vue?vue&type=template&id=6c40d9d3"
import script from "./CreateFormulaTemplateForm.vue?vue&type=script&lang=js"
export * from "./CreateFormulaTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports